import React, { useEffect, useState } from 'react';
import OrdersModel from './OrdersModel';
import OrderHistoryModal from './OrderHistoryModal/OrderHistoryModal';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setOrderDetailsHistory } from '../../../../store';
import { useDispatch, useSelector } from 'react-redux';
import { formatDateToShortString } from '../../../common/common';
import axios from 'axios';

const Orders = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const userInfo = useSelector((state) => state.analysisData.userInfo);

  // const [orderDetailsHistory, setOrderDetailsHistory] = useState([]);
  const orderDetailsHistory = useSelector((state) => state.analysisData.orderDetailsHistory);
  const activeStoreData = useSelector((state) => state.analysisData.activeStoreData);

  const dispatch = useDispatch();
  const [orderDetailsId, setOrderDetailsId] = useState("");
  const [orderInfo, setOrderInfo] = useState({
    noOfOrders: "",
    noOfProducts: "",
    fromDate: "",
    endDate: "",
    uniqueProducts: "",
    totalProductsQuantity: ""
  })
  // const [uniqueProducts, setUniqueProducts] = useState("")
  // const [totalProductsQuantity, setTotalProductsQuantity] = useState("")
  const [orderDetailsLoading, setOrderDetailsLogin] = useState(false);
  const [isFetched, setIsFetched] = useState(false);
  const [defaultOrderDetails, setDefaultOrderDetails] = useState({});

  const [formData, setFormData] = useState({
    start_date: '',
    end_date: '',
  });
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const { id } = useParams();
  const navigate = useNavigate();


  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors({});
  };


  const handleQuickSelect = (days) => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - days + 1); // Include today

    const format = (date) => date.toISOString().split('T')[0];

    setFormData({
      start_date: format(start),
      end_date: format(end)
    })
    setErrors({})
  };




  const validate = () => {
    const newErrors = {};
    if (!formData.start_date) newErrors.start_date = 'Start date is required';
    if (!formData.end_date) newErrors.end_date = 'End date is required';
    if (formData.start_date && formData.end_date) {
      const start = new Date(formData.start_date);
      const end = new Date(formData.end_date);

      if (start >= end) {
        newErrors.start_date = "Start date must be earlier than end date";
        newErrors.end_date = "End date must be later than start date";
      }
    }
    return newErrors;
  };

  const handleSubmit = async () => {
    if (!activeStoreData.isActive) {
      alert("Store is inactive. Contact admin to enable order fetching.");
      return;
    }
    alert("If you need to fetch new orders, Please contact Admin.");
    return;
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setLoading(true)
      const response = await fetch(`${process.env.REACT_APP_FETCH_ORDERS}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`, // optional if needed
        },
        body: JSON.stringify({
          start_date: formData.start_date,
          end_date: formData.end_date,
          store_id: id,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.detail.isExpireToken) {
          const token = localStorage.removeItem("token");
          const user = localStorage.removeItem("userInfo");
          navigate("/login")
        }
        throw new Error(data.detail?.message || 'Failed to fetch orders');
      }

      // alert('Orders fetched successfully!');
      toast.success("Orders fetched successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
      getOrderDetails();
      // onClose();
      // setIsFetched(true)
    } catch (err) {
      // alert(`Error: ${err.message}`);
      toast.error(err.message, {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };


  const getOrderDetails = async () => {
    try {
      setOrderDetailsLogin(true)
      const response = await fetch(`${process.env.REACT_APP_FETCH_ORDER_DETAILS}?store_id=${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await response.json();
      if (!response.ok) {
        if (data.detail.isExpireToken) {
          const token = localStorage.removeItem("token");
          const user = localStorage.removeItem("userInfo");
          navigate("/login")
        }
        throw new Error(data.detail?.message || 'Failed to connect store');
      }
      dispatch(setOrderDetailsHistory(data.data.reverse()))
      if (isFetched) {
        setIsFetched(false)
        // toast.success("Order fetched successfully!", {
        //   position: "top-right",
        //   autoClose: 3000,
        // });
      }

    } catch (err) {
      toast.error(err.message, {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setOrderDetailsLogin(false)
    }
  }



  const set_Default_Order_Details = async (order_details_id, isDefault = true) => {
    try{
      let url = `${process.env.REACT_APP_API_END_POINT}/order/set-default-order-details`
      const response = await axios.put(url, null, {
        params: {
          order_details_id,
          isDeafult: isDefault,
          store_id: id
        }
      });
      setDefaultOrderDetails({
        [order_details_id]: isDefault
      })
      toast.success('Default order updated successfully');
    }catch(error){
      if (error.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error('Failed to set default order');
    }
  };

  useEffect(() => {
    if (!modalOpen && isFetched) {
      getOrderDetails();
    }
  }, [modalOpen])
  useEffect(() => {
    // if (orderDetailsHistory.length === 0) {
      getOrderDetails();
    // }
  }, [])

  return (
    <main className=" mx-auto px-4 py-6 sm:px-6 lg:px-8">

      <div className="py-4   flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Order Analysis Dashboard</h2>
          <p className="mt-1 text-sm text-gray-500">It displays all fetched orders along with detailed information. Use this data to run in-depth product, bundle, and sales performance analysis effortlessly.</p>
        </div>
        <div className="flex space-x-2">
          {userInfo.roles.includes("admin") && (
            <button
              className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-blue-700 transition duration-300 flex items-center space-x-2"
              onClick={() => setModalOpen(true)}
            >
              <i className="fas fa-plus-circle"></i>
              <span>Order Report</span>
            </button>
          )}
          <button
            className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg text-sm hover:bg-gray-300 transition duration-300"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>
        </div>

      </div>



      <div id="recommendations-tab-content" className="fade-in">
        <div className="bg-white shadow rounded-lg overflow-hidden mb-8">



          {/* <div className="px-6 py-4 flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="mb-4 md:mb-0">
              <label className="block text-sm font-medium text-gray-700 mb-1">Date Range</label>
              <div className="flex items-start space-x-2">
                <div>
                <input
                  type="date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleChange}
                  className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
                {errors.start_date && <p className="text-sm text-red-600 mt-1">{errors.start_date}</p>}
                </div>
                <span className="text-gray-500 cstm_input_divider">to</span>
                <div>
                <input
                  type="date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleChange}
                  className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
                {errors.end_date && <p className="text-sm text-red-600 mt-1">{errors.end_date}</p>}
                </div>
                <button
                  onClick={handleSubmit}
                  disabled={loading}
                  className="ml-2 px-4 py-2.5 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  {loading ? "Please wait..." : "Fetch Orders"}
                </button>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Quick Select</label>
              <div className="flex space-x-2">
                {[7, 30, 90].map((days) => (
                  <button
                    key={days}
                    onClick={() => handleQuickSelect(days)}
                    className="quick-date-btn px-3 py-1 text-sm bg-gray-100 rounded hover:bg-gray-200"
                  >
                    Last {days} Days
                  </button>
                ))}
              </div>
            </div>
          </div>  */}
          {/* <br /> */}

          <div className="">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"># Report</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Order Period</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Order Information</th>

                    {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">No. Of Orders</th> */}
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Set Default</th>

                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {orderDetailsHistory.length > 0 ? (
                    orderDetailsHistory.map((entry, index) => {
                      const isChecked = Object.keys(defaultOrderDetails).length === 0
                      ? entry.isDefault // ⬅️ user updated value
                      : defaultOrderDetails[entry._id] || false;
                      
                      return (
                        <tr key={index}>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"><span className="text-sm font-medium">Order Report {orderDetailsHistory.length - index}</span></td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            <span className="text-sm font-medium">From Date:</span> <span className="text-xs text-gray-500">{formatDateToShortString(entry.start_date)}</span> <br />
                            <span className="text-sm font-medium">To Date:</span> <span className="text-xs text-gray-500">{formatDateToShortString(entry.end_date)}</span>
                          </td>
                          {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"></td> */}
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            <span className="text-sm font-medium">Total Orders:</span> <span className="text-xs text-gray-500">{(entry.noOfOrders ? entry.noOfOrders.toLocaleString('en-US') : "N/A")}</span> <br />
                            <span className="text-sm font-medium">Line Items:</span> <span className="text-xs text-gray-500">{(entry.noOfProducts ? entry.noOfProducts.toLocaleString('en-US') : entry.no_of_orders.toLocaleString('en-US'))}</span>
                            <button
                              className="text-blue-600 hover:text-blue-900 ml-2"
                              onClick={() => {
                                setShowModal(true);
                                setOrderDetailsId(entry._id);
                                setOrderInfo({
                                  noOfOrders: entry.noOfOrders,
                                  uniqueProducts: entry.unique_product_count,
                                  totalProductsQuantity: entry.total_product_quantity,
                                  noOfProducts: entry.noOfProducts || entry.no_of_orders,
                                  fromDate: formatDateToShortString(entry.start_date),
                                  endDate: formatDateToShortString(entry.end_date)
                                })
                              }}
                            >
                              <i className="fa-solid fa-eye"></i>
                            </button>
                            <br />
                            <span className="text-sm font-medium">Total Unique Products:</span> <span className="text-xs text-gray-500">{(entry.noOfUniqueProducts ? entry.noOfUniqueProducts.toLocaleString('en-US') : "N/A")}</span>
                            <br />
                            <span className="text-sm font-medium">Total Products Quantity:</span> <span className="text-xs text-gray-500">{(entry.total_product_quantity ? entry.total_product_quantity.toLocaleString('en-US') : "N/A")}</span>
  
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {
                              userInfo.roles.includes("admin") &&
                              <button
                                className="gradient-bg text-white px-4 py-2 rounded-lg hover:opacity-90 transition duration-300 m-r-3"
                                onClick={() => {
                                  // if(!activeStoreData.isActive){
                                  //   alert("Store is inactive. Contact admin to enable run new analysis.");
                                  //   return;
                                  // }
  
                                  navigate(`/run-analysis`, {
                                    state: { id: (entry._id), reportId: (orderDetailsHistory.length - index), start_date: entry.start_date, end_date: entry.end_date }
                                  })
                                }}
                              >
                                <i className="fa-solid fa-refresh mr-2"></i>
                                Run New MBA
                              </button>
                            }
  
                            <button
                              className="gradient-bg text-white px-4 py-2 rounded-lg hover:opacity-90 transition duration-300 ml-2"
                              onClick={() => {
                                navigate("/rfm", {
                                  state: { order_details_id: entry._id, reportId: (orderDetailsHistory.length - index), start_date: entry.start_date, end_date: entry.end_date }
                                });
                                // localStorage.setItem("order_details_id", entry._id)
                              }}
                            // style={{display:"none"}}
                            >
                              <i className="fa-solid fa-eye mr-2"></i>
                              RFM Analysis 
                            </button>
                            {/* <button
                              className="gradient-bg text-white px-4 py-2 rounded-lg hover:opacity-90 transition duration-300"
                              onClick={() => {
                                navigate("/k-means", {
                                  state: { order_details_id:entry._id ,reportId: (orderDetailsHistory.length - index), start_date: entry.start_date, end_date: entry.end_date }
                                }); 
                                // localStorage.setItem("order_details_id", entry._id)
                              }}
                            >
                              <i className="fa-solid fa-eye mr-2"></i>
                              Customer Analysis Report Kmeans
                            </button> */}
                            {
                              entry.no_of_analysis > 0 &&
                              <button
                                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition  ml-2"
                                onClick={() => {
                                  navigate("/history-analysis", {
                                    state: { order_details_id: entry._id, reportId: (orderDetailsHistory.length - index), start_date: entry.start_date, end_date: entry.end_date }
                                  });
                                  // localStorage.setItem("order_details_id", entry._id)
                                }}
                              >
                                <i className="fa-solid fa-eye mr-2"></i>
                                Market Basket Analysis
                              </button>
                            }
  
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            <label className="inline-flex items-center">
                              <input 
                                type="checkbox" 
                                checked={isChecked} 
                                readOnly 
                                className="accent-green-600 w-4 h-4 rounded" 
                                onClick={(e)=>{
                                  if(e.target.checked === false)
                                    return
                                  set_Default_Order_Details(entry._id,e.target.checked)
                                  
                                }}
                              />
                            </label>
                          </td>
                        </tr>
                      )
                    }
                    )
                  ) : (
                    <>
                      {
                        !orderDetailsLoading &&
                        <tr>
                          <td colSpan="5" className="text-center px-6 py-6 text-gray-500">
                            No Orders found.
                          </td>
                        </tr>
                      }
                      {
                        orderDetailsLoading &&
                        <tr>
                          <td colSpan="5" className="text-center px-6 py-6">
                            <div className="flex justify-center items-center">
                              <svg className="animate-spin h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                              </svg>
                              <span className="ml-2 text-gray-500">Loading...</span>
                            </div>
                          </td>
                        </tr>
                      }
                    </>
                  )}
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

      {
        modalOpen && id &&
        <OrdersModel isOpen={modalOpen} onClose={setModalOpen} storeId={id} setIsFetched={setIsFetched} />
      }
      {showModal && orderDetailsId && (
        <OrderHistoryModal
          isOpen={showModal}
          onClose={() => {
            setShowModal(false);
            setOrderDetailsId(null);
          }}
          orderDetailsId={orderDetailsId}
          orderInfo={orderInfo}

        />
      )}

    </main>
  );
};

export default Orders;
